import { apiRequests } from '../utilities/axios-factory'
import store from '../store'

function findExclusionPeriods (filter) {
  return apiRequests.get('/v1/revenue-exclusion-period/', {
    params: { filter },
    headers: { Authorization: store.getters.getTokenId }
  }).then((result) => result.data)
}

function findTotalExclusionPeriods ({ where }) {
  return apiRequests.get('/v1/revenue-exclusion-period/count/', {
    params: { where },
    headers: { Authorization: store.getters.getTokenId }
  }).then((result) => result.data)
}

function getExclusionPeriod ({ id, filter }) {
  return apiRequests.get('/v1/revenue-exclusion-period/' + id + '/', {
    params: { filter },
    headers: { Authorization: store.getters.getTokenId }
  }).then((result) => result.data)
}

function createExclusionPeriod (data) {
  return apiRequests.post('/v1/revenue-exclusion-period/', data, {
    headers: { Authorization: store.getters.getTokenId }
  }).then((result) => result.data)
}

function updateExclusionPeriod (data) {
  const payload = Object.assign({}, data)
  delete payload.id
  return apiRequests.patch('/v1/revenue-exclusion-period/' + data.id + '/', payload, {
    headers: { Authorization: store.getters.getTokenId }
  }).then((result) => result.data)
}

function deleteExclusionPeriod ({ id }) {
  return apiRequests.delete('/v1/revenue-exclusion-period/' + id + '/', {
    headers: { Authorization: store.getters.getTokenId }
  }).then((result) => result.data)
}

function getExclusionPeriodTemplate () {
  return {
    agencyId: '',
    transportationProfileId: null,
    recurrenceType: 'once',
    periodStart: null,
    periodEnd: null,
    dayOfWeekStart: null,
    dayOfWeekEnd: null,
    dayOfMonthStart: null,
    dayOfMonthEnd: null,
    monthStart: null,
    monthEnd: null,
    holidayKey: null,
    holidayOffsetDays: 0,
    holidayDurationDays: 1,
    reason: '',
    isActive: true
  }
}

export {
  findExclusionPeriods,
  findTotalExclusionPeriods,
  getExclusionPeriod,
  createExclusionPeriod,
  updateExclusionPeriod,
  deleteExclusionPeriod,
  getExclusionPeriodTemplate
}
